<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/a2eJTQ/tc-custom/9781952225413.jpg?1705838702525" alt="This image is the cover for the book True Crime Chronicles, Volume Two"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">True Crime Chronicles, Volume Two
      </h1>
      <p class="bookDescription body article font2">
        <b>Newspaper reports of Jack the Ripper, Jesse James, Butch Cassidy and the Sundance Kid, and others compiled by the <i>New York Times</i>–bestselling author.</b><br/>  <br/> Former detective and bestselling author Mike Rothmiller has brought together classic works of journalism that will take the reader on a fascinating journey back in time to when these horrific tales mesmerized a nation. Some may find these articles and their descriptions of people and crimes shocking by today’s standards, but they are representative of the most colorful true crime stories of the day<br/><br/><i>True Crime Chronicles, Volume Two</i> includes stories about Billy the Kid, Jesse James, the legendary “Jack the Ripper,” Lizzie Halliday, Anna Maria Zwanziger, Jack the Haircutter, Butch Cassidy and the Sundance Kid, The Nebraska Murderer, and many more shocking stories. Follow along as these reporters from another century visit the crime scenes, interview witnesses, and pen the stories of murder, evil, and swift frontier justice.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mike Rothmiller
      </h2>
      
      <p class="authorDescription body article">Mike Rothmiller is a New York Times Bestselling author, historian, a former cop,,and an Army medic. He's a former TV Reporter, an award-winning documentary television producer, and television host for ESPN, PBS, and other international television markets. His non-fiction book, My Hero, Military, Kids Write About Their Moms and Dads (St. Martin's Press) received international acclaim and is the only book to have forwards written by three living Presidents and General Norman Schwarzkopf. Additionally, he's been a corporate President/CEO and directed three divisions of Sony Electronics EMCS-America, and he briefed the President of the United States.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22b2abc4